import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import "../../stylesheet/prescription.css";
import { FaBell } from "react-icons/fa";
import { RiSettings4Fill } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import profile from "../../images/profile.png";
import searchIcon from "../../images/search.svg";
import Notification from "./Notification";
import Settings from "./Settings";
import SideBarContext from "../../context/ContextApi";
import { useSelector } from 'react-redux';
import { FaHamburger } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";


import { useDispatch } from "react-redux";
import { updatePatient, toggleSideBar } from "../../reducers/sideBarReducer";

const Topnav = () => {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.appStore.sideBar.status); 
  const location = useLocation();
  const [notificationIsOpen, setNotificationIsOpen] = useState(false);
  const [settingsIsOpen, setSettingsIsOpen] = useState(false);

  let heading;
  const handleToggleSideBar = () => {
    dispatch(toggleSideBar(!status)); 
  };

  switch (location.pathname) {
    case "/dashboard":
      heading = (
        <div className="flex gap-2">
          <img src={searchIcon} alt="" />
          <input
            type="text"
            name="search"
            placeholder="search"
            className="outline-none"
          />
        </div>
      );
      break;

    case "/prescription":
      heading = "Prescriptions";
      break;

    case "/partners":
      heading = "Partners";
      break;

    case "/inventory":
      heading = "Inventory";
      break;

    case "/patients":
      heading = "Patients";
      break;

    case "/appointments":
      heading = "Appointments";
      break;

    case "/profile-settings":
      heading = "Profile settings";
      break;

    case "/partner-settings":
      heading = "Partner settings";
      break;

    case "/payment-settings":
      heading = "Payment settings";
      break;

    case "/subscriptions":
      heading = "Subscriptions";
      break;

    default:
  }
  return (
    <div className="top_nav">
      <h1>{heading}</h1>
      <div className="top_nav_icons">
        <div className="relative">
          <FaBell
            onClick={() => {
              setNotificationIsOpen(!notificationIsOpen);
              setSettingsIsOpen(false);
            }}
            className={notificationIsOpen && "text-blue-500"}
          />
          {notificationIsOpen && (
            <div className="absolute right-[100%]">
              <Notification />
            </div>
          )}
        </div>
        <div className="relative">
          <RiSettings4Fill
            onClick={() => {
              setSettingsIsOpen(!settingsIsOpen);
              setNotificationIsOpen(false);
            }}
            className={settingsIsOpen && "text-blue-500"}
          />
          {settingsIsOpen && (
            <div className="absolute right-[100%]">
              <Settings />
            </div>
          )}
        </div>
        <div className="nav_profile">
          <img src={profile} alt="" />
          <p>Chioma A.</p>
          <span>
            <IoIosArrowDown />
          </span>
        </div>
        <div className="hamburger" onClick={handleToggleSideBar}>
        <button onClick={handleToggleSideBar}>
          {
            status? (
              <FaTimes size={20} />
            ) : (
              <FaHamburger size={20} />
            )
          }
          </button>
        </div>
      </div>
    </div>
  );
};

export default Topnav;
